export enum EbayListingStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Archived = "ARCHIVED",
}
